import styled from 'styled-components'

const SpinnerWrapper = styled.div`
  /* display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
  width: 100%; */
`

const Spin = styled.h6`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 4px solid transparent;
  margin-left: 8px;
  /* background-color:red; */

  border-top-color: #fff;
  /* border-top-color: red; */

  animation: spin 1s linear infinite;
  -webkit-animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    to {
      -webkit-transform: rotate(360deg);
    }
  }
`

const Spinner = () => {
  return (
    <SpinnerWrapper>
      <Spin />
    </SpinnerWrapper>
  )
}

const GeneralSpinner = styled(Spin)`
  height: 60px;
  width: 60px;
  border-top-color: ${({ theme }) => theme.colors.primary};
  border-right-color: ${({ theme }) => theme.colors.primary};
`

export { Spinner, GeneralSpinner }
